export const languages = ["ru", "en", "br", "in", "es", "id", "pk", "ph", "tr", "ua"];
